import React from 'react';
import { useLocation } from 'react-router';

export const useQuery = (): URLSearchParams => {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
};
